import useOrganizationQueries from "./useOrganizationQueries";
import { mapOrganization } from "../constants/map/organization";

const useOrganizationEdit = () => {
  const { organization, updateAnOrganization, state } =
    useOrganizationQueries();
  const { fieldDocumentsIds } = state;

  const loading = organization.isLoading || updateAnOrganization.isLoading;

  // Extract error from mutation - could be from API exception or network error
  let error = null;
  if (updateAnOrganization.error) {
    try {
      // Try to parse the error if it's a stringified API response
      const parsed = JSON.parse(updateAnOrganization.error.message);
      error = parsed;
    } catch {
      // If not JSON, use the error as is
      error = updateAnOrganization.error;
    }
  }

  return {
    organizationData: mapOrganization(organization?.data),
    updateAnOrganization,
    fieldDocumentsIds,
    loading,
    error,
  };
};

export default useOrganizationEdit;
